import { makeStyles, tokens } from "@fluentui/react-components";

export const useTabItemStyles = makeStyles({
  tabPseudo: {
    "::after": {
      backgroundColor: "transparent",
    },
    "::before": {
      backgroundColor: "transparent",
    },
  },
  tab: {
    borderRadius: "15px 15px 0 0",
    padding: "8px 10px",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: tokens.colorBrandBackground2Hover,
    },
    "&:active": {
      backgroundColor: tokens.colorBrandBackground2Hover,
      "::after": {
        display: "none",
      },
    },
  },
  selectedTab: {
    boxShadow: tokens.shadow2,
    "&:hover": {
      backgroundColor: "white",
      "::after": {
        display: "none",
      },
      "::before": {
        display: "none",
      },
    },
    "&:active": {
      backgroundColor: tokens.colorBrandBackground2Hover,
    },
    backgroundColor: "white",
  },
  tabItem: {
    overflow: "hidden",
    display: "block",
    maxWidth: "100px",
    textAlign: "start",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
